type Props = {
    stock: any;
};

const StockSummaryCard = ({ stock }: Props) => {
    return (
        <div className="bg-white p-5 rounded-2xl shadow-sm">
            <h2 className="text-lg font-semibold mb-4">Stock Summary</h2>

            <div className="flex flex-col gap-3 text-sm">
                <div className="flex justify-between">
                    <span>Start Date</span>
                    <span>{stock?.start_date}</span>
                </div>

                <div className="flex justify-between">
                    <span>End Date</span>
                    <span>{stock?.end_date}</span>
                </div>

                <div className="flex justify-between">
                    <span>Total Inward Qty</span>
                    <span>{stock?.total_inward_quantity}</span>
                </div>

                <div className="flex justify-between font-semibold">
                    <span>Total Purchase</span>
                    <span>QAR {stock?.total_buyprice_sum}</span>
                </div>
            </div>
        </div>
    );
};

export default StockSummaryCard;